<div class="add-f-treeview">
  <sysque-tab #tabPanel [titleClick]="titleClick"  [content]="content"></sysque-tab>
</div>
